<button class="icon-btn">
  <span><img [src]="icon" alt=""></span>
  {{content}}
</button>
